import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Quote from 'app/components/Quote'
import Button from 'app/components/ButtonDefault'
import ToggleBox from 'app/components/ToggleBox'
import './styles.scss'

const bc = 'activity'

const Activity = ({ t, activity, isMobile, onClick, submitting }) => (
  <div className={bc}>
    <div className={`${bc}__header`}>
      <div className={`${bc}__name`}>{activity.name}</div>
      {!isMobile && (
        <Button disabled={submitting} sm primary onClick={onClick}>
          {t('I Commit')}
        </Button>
      )}
    </div>
    <div className={`${bc}__description`} dangerouslySetInnerHTML={{ __html: activity.description }} />
    {isMobile ? (
      <Fragment>
        <ToggleBox contentLabel="Activity details" custom>
          <Quote
            proQuote={activity.proQuote}
            proQuoteAuthor={activity.proQuoteAuthor}
            image={activity.image}
            videoId={activity.videoId}
            videoThumbnail={activity.videoThumbnail}
            className={`${bc}__quote`}
          />
        </ToggleBox>
        <Button disabled={submitting} className={`${bc}__mobile-button`} primary onClick={onClick}>
          {t('I Commit')}
        </Button>
      </Fragment>
    ) : (
      <Quote
        proQuote={activity.proQuote}
        proQuoteAuthor={activity.proQuoteAuthor}
        image={activity.image}
        videoId={activity.videoId}
        videoThumbnail={activity.videoThumbnail}
        className={`${bc}__quote`}
      />
    )}
  </div>
)

Activity.defaultProps = {
  onClick: Function.prototype,
}

Activity.propTypes = {
  onClick: PropTypes.func,
  activity: PropTypes.object,
  isMobile: PropTypes.bool,
  submitting: PropTypes.bool,
}

export default Activity
